import React from 'react';
import { useTranslation } from 'react-i18next';
import PieChart from '../../../charts/PieChart'
import { Loader } from '../../../components';
import versionCompare from '../../../../services/versionCompare';
import { useGetAppAdminOsVersionPerOsQuery } from '../../../../api/appAdminApiSlice';
import Block from '../../../Block';

const DevicePerOsVersion = ({appId, ...props}) => {
  const { t } = useTranslation();
  const { data = [], isSuccess, isError, refetch } = useGetAppAdminOsVersionPerOsQuery(appId)
  const loaderProps = { success: isSuccess, error: isError, retry: refetch }
  const pieData = [...data].sort((a,b) => versionCompare(b.major_os_version,a.major_os_version) )
                      .map((x)=>({"name":x.major_os_version,"y":x.active_devices}))

  return (
    <Block title={t('version.device_per_os_version')}{...props}>
      <Loader {...loaderProps} minHeight={"100%"}>
        <PieChart data={pieData}  legendOptions={{show: false}} datalabels/>
      </Loader>
    </Block>
  )
}

export default DevicePerOsVersion
